import {groupBy} from '@raison/toolbox';
import React from 'react';
import {useSelector} from 'react-redux';
import {For, Option, renderEmptyTab} from '~/processes/dashboard/CurrencySelectionPage/components';
import {CurrencyOptionView} from '~/processes/dashboard/CurrencySelectionPage/interfaces';
import {selectFiatProviders} from '~/processes/dashboard/selectors/selectFiatProviders';
import ListLayout from '~/shared/layouts/ListLayout/ListLayout';
import {useAppDispatch} from '~/shared/store';

type Props = {
    data: CurrencyOptionView[];
};

const PROVIDER_ID_PLACEHOLDER = 'PROVIDER_ID_PLACEHOLDER';

export function AccountsGroupedByProvider({data}: Props) {
    const dispatch = useAppDispatch();
    const groupedData = groupBy(data, item => item.providerId || PROVIDER_ID_PLACEHOLDER);
    const providers = useSelector(selectFiatProviders);

    return (
        <For each={Object.entries(groupedData)} empty={renderEmptyTab()}>
            {([providerId, items]) => {
                const provider = providers?.find(provider => Number(providerId) === provider.id);
                return (
                    <div key={providerId}>
                        {provider && (
                            <div className='fv-heading-s px-4 pb-2 pt-4 font-bold text-neutral-100'>
                                {provider.name}
                            </div>
                        )}
                        <ListLayout>
                            <For each={items} empty={renderEmptyTab()}>
                                {op => (
                                    <Option
                                        key={`${op.providerId}:${op.shortName}`}
                                        {...op}
                                        onClick={() => dispatch(op.clickAction)}
                                    />
                                )}
                            </For>
                        </ListLayout>
                    </div>
                );
            }}
        </For>
    );
}
